<template>
  <div>
    <pie-chart
        ref="pieChartAll"
        :chart-data="pieChartDataAll"
        :options="chartOptionsAll">
    </pie-chart>
  </div>
</template>

<script>
import {Pie} from "vue-chartjs";
import ChartDataLabels from "chartjs-plugin-datalabels";


export default {
  name: 'ChartPieStat',
  components: {
    "pie-chart": {
      extends: Pie,
      props: ["chartData", "options"],
      mounted() {
        this.addPlugin(ChartDataLabels)
        this.renderChart(this.chartData, this.options)
      }
    }
  },
  props: {
    stat: {
    },
  },
  computed: {
  },
  data () {
    return {
      chartOptionsAll: {
        responsive: true,
        maintainAspectRatio: false,
        plugins: {
          datalabels: {
            formatter: (value, ctx) => {
              let total = ctx.chart.data.datasets[0].data.reduce(
                  (a, b) => a + b,
                  0
              )
              let percentage = ''
              if (total !== 0 && value !== 0) {
                percentage = ((value / total) * 100).toFixed(2) + "%"
              }
              return percentage
            },
            color: "#000",
            font: {
              weight: "bold",
            },
          }
        }
      },
      pieChartDataAll: null,

    }
  },
  created () {
  },
  mounted () {
    this.generatePieChartDataStatus(this.stat)
  },
  beforeDestroy () {
  },
  methods: {
    generatePieChartDataStatus(data) {
      let statusCounts = {
        AllTestOk: 0,
        NoEnrollment: 0,
        NoPlanned: 0,
        Planned: 0,
        InTesting: 0,
      };

      data.forEach((item) => {
            const now = new Date()

            if ((parseInt(item.TotalTest) === parseInt(item.TotalOk)) && item.TotalOk != 0 && item.TotalTest != 0) {
              statusCounts.AllTestOk++
            } else if (item.UserCount == 0 ) {
              statusCounts.NoEnrollment++
            } else if (!item.StartDate || !item.EndDate ) {
              statusCounts.NoPlanned++
            } else {
              const start = new Date(item.StartDate)
              const end = new Date(item.EndDate)

              if (end < now) {
                statusCounts.NoPlanned++
              } else if (start > now) {
                statusCounts.Planned++
              } else {
                statusCounts.InTesting++
              }
            }
          }
      );

      this.pieChartDataAll = {
        labels: [this.$t('account_tb.session_test.all_test_ok'), this.$t('account_tb.session_test.no_enrollment'),this.$t('account_tb.session_test.scheduled_not_planned'), this.$t('account_tb.session_test.scheduled_upcoming'), this.$t('account_tb.session_test.in_progress')],
        datasets: [
          {
            data: [
              statusCounts.AllTestOk,
              statusCounts.NoEnrollment,
              statusCounts.NoPlanned,
              statusCounts.Planned,
              statusCounts.InTesting,
            ],
            backgroundColor: [
              this.getCustomColor("AllTestOk", 0.8),
              this.getCustomColor("NoEnrollment", 0.8),
              this.getCustomColor("NoPlanned", 0.8),
              this.getCustomColor("Planned", 0.8),
              this.getCustomColor("InTesting", 0.8),
            ],
          },
        ],
      }

      this.$nextTick(() => {
        if (this.$refs.pieChartAll) {
          this.$refs.pieChartAll.renderChart(
              this.pieChartDataAll,
              this.chartOptionsAll
          )
        }
      })
    },
    getCustomColor(key, alpha = 1) {
      let r, g, b
      r = Math.floor(Math.random() * 256)
      g = Math.floor(Math.random() * 256)
      b = Math.floor(Math.random() * 256)
      switch (key) {
        case 'InTesting': // Orange vif
          r = 230;
          g = 159;
          b = 0;
          break;
        case 'NoPlanned': // Violet moyen
          r = 117;
          g = 112;
          b = 179;
          break;
        case 'OK': // Bleu clair
          r = 40;
          g = 167;
          b = 69;
          break;
        case 'connector 3': // Gris neutre
        case 'NoEnrollment': // Gris neutre
          r = 153;
          g = 153;
          b = 153;
          break;
        case 'CONF_NOT_FOUND': // Vert turquoise clair
          r = 117;
          g = 112;
          b = 179;
          break;
        case 'Planned': // Bleu profond
          r = 0;
          g = 114;
          b = 178;
          break;
        case 'KO': // Brun chaud
          r = 204;
          g = 0;
          b = 0;
          break;
        case 'connector 7': // Cyan clair
          r = 0;
          g = 204;
          b = 204;
          break;
        case 'AllTestOk': // Vert foncé
          r = 0;
          g = 143;
          b = 57;
          break;
        case 'NULL': // Rouge atténué
          r = 156;
          g = 163;
          b = 175;
          break;
        case '': // Vide ou non spécifié
          break;
      }
      return `rgba(${r}, ${g}, ${b}, ${alpha})`
    }
  }
}
</script>

<style scoped>
.result-vignette {
  display: inline-block;
  width: 12px;
  height: 12px;
  border-radius: 50%;
  margin-right: 8px;
}

.result-mtch {
  background-color: rgba(0, 143, 57, 0.8);
}

.result-nmtc {
  background-color: rgba(204, 0, 0, 0.8);
}

.result-cmtc {
  background-color: rgba(230, 159, 0, 0.8);
}

.result-noap {
  background-color: rgba(153, 153, 153, 0.8);
}
</style>
